module.exports = require("nodemailer");